import TodoListItemViewState from '../store/schema/TodoListItemViewState';
import { action } from 'satcheljs';
import { Datapoints } from '../datapoints';
import { IPoint } from 'office-ui-fabric-react/lib/Utilities';

export const showTodoContextMenu = action(
    'showTodoContextMenu',
    (itemId: string, anchor: IPoint) => ({
        itemId,
        anchor,
    })
);

export const hideTodoContextMenu = action('hideTodoContextMenu', () => ({}));

export const setTodoListItemViewState = action(
    'setTodoListItemViewState',
    (itemId: string, viewState: TodoListItemViewState) => ({
        itemId,
        viewState,
    })
);

export const clearFocusTodoId = action('clearFocusTodoId');

export const showCompletedTasks = action('showCompletedTasks', () => ({
    datapointConfig: Datapoints.todoPanelActionShowRecentlyCompleted.datapoint(),
}));

export const hideCompletedTasks = action('hideCompletedTasks', () => ({
    datapointConfig: Datapoints.todoPanelActionHideRecentlyCompleted.datapoint(),
}));
